import { gql } from "urql"

export const REMOVE_PORTAL_DOCUMENT_MUTATION = gql`
  mutation RemovePortalDocument($id: ID!) {
    removePortalDocument(id: $id) {
      result
      errors
    }
  }
`
